const VISITOR_ID_KEY = 'portfolio_visitor_id';
const VISIT_RECORDED_KEY = 'portfolio_view_recorded';
const LOCAL_COUNT_KEY = 'portfolio_dev_view_count';
const LOCAL_VISITORS_KEY = 'portfolio_dev_visitors';
const VIEW_COUNT_URL = '/.netlify/functions/view-count';

function isLocalHost() {
  if (typeof window === 'undefined') {
    return false;
  }

  return ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname);
}

function isLocalCounterMode() {
  return (
    process.env.NODE_ENV === 'development' ||
    process.env.NODE_ENV === 'test' ||
    isLocalHost()
  );
}

function getVisitorId() {
  let visitorId = localStorage.getItem(VISITOR_ID_KEY);

  if (!visitorId) {
    visitorId =
      typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : `v-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
    localStorage.setItem(VISITOR_ID_KEY, visitorId);
  }

  return visitorId;
}

function alreadyRecordedInBrowser() {
  return localStorage.getItem(VISIT_RECORDED_KEY) === '1';
}

function markRecordedInBrowser() {
  localStorage.setItem(VISIT_RECORDED_KEY, '1');
}

function getLocalVisitors() {
  try {
    return JSON.parse(localStorage.getItem(LOCAL_VISITORS_KEY) || '[]');
  } catch {
    return [];
  }
}

function recordLocalVisitor(visitorId) {
  const visitors = getLocalVisitors();
  if (visitors.includes(visitorId)) {
    return false;
  }

  visitors.push(visitorId);
  localStorage.setItem(LOCAL_VISITORS_KEY, JSON.stringify(visitors));
  localStorage.setItem(LOCAL_COUNT_KEY, String(visitors.length));
  return true;
}

function getLocalCount() {
  return getLocalVisitors().length;
}

export async function recordViewVisit() {
  if (alreadyRecordedInBrowser()) {
    return;
  }

  const visitorId = getVisitorId();

  if (isLocalCounterMode()) {
    recordLocalVisitor(visitorId);
    markRecordedInBrowser();
    return;
  }

  try {
    const response = await fetch(VIEW_COUNT_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ visitorId }),
    });

    if (response.ok) {
      markRecordedInBrowser();
    }
  } catch {
    // Silent — counting is best-effort
  }
}

export async function fetchViewCount() {
  if (isLocalCounterMode()) {
    return getLocalCount();
  }

  try {
    const response = await fetch(VIEW_COUNT_URL, { method: 'GET' });
    if (!response.ok) {
      return null;
    }

    const data = await response.json();
    return typeof data.count === 'number' ? data.count : null;
  } catch {
    return null;
  }
}

export function resetDevViewCount() {
  if (!isLocalCounterMode()) {
    return;
  }

  localStorage.removeItem(LOCAL_COUNT_KEY);
  localStorage.removeItem(LOCAL_VISITORS_KEY);
  localStorage.removeItem(VISITOR_ID_KEY);
  localStorage.removeItem(VISIT_RECORDED_KEY);
}
